import React, {Component} from 'react';
import PhoneDetail from './Components/PhoneDetail';

export default class PhoneListHelper extends Component {
    render(){
        let phoneList = this.props.phoneList;
        let allNotRetail = this.props.allNotRetail;
        let fiveGLabel = this.props.fiveGLabel;

        let displayItem = phoneList.map(
            (o, i) => { return (<PhoneDetail allNotRetail={allNotRetail} phoneObj={o} index={i} fiveGLabel={fiveGLabel} />) }
        )


        return(
            <div className="desktopPhoneList my-auto">
                <div className="phonelist-carousel">{displayItem}</div>
            </div>
        );
    }
}